import { tryCatch } from '@wix/funnel-utils'
import { useCallback, useEffect, useRef, useState } from 'react'

import { ambassadorHttpClient } from '../../../api/httpClient'
import { withMonitoring } from '../../../monitoring/withMonitoring'

type State = { type: 'loading' } | { type: 'error'; error: Error } | { type: 'ready'; email: string }

export const useLoadEmail = () => {
  const [state, setState] = useState<State>({ type: 'loading' })

  const isUnmount = useRef(false)
  const reload = useCallback(async () => {
    setState({ type: 'loading' })
    const [error, response] = await tryCatch(() =>
      withMonitoring(async () => {
        const res = await ambassadorHttpClient.get('/_api/wix-html-login-webapp/user/getUserDetails')
        const email = res.data.payload.email
        if (!email) {
          throw new Error('no email in the getUserDetails response')
        }
        return res
      }, 'load-current-email'),
    )
    if (isUnmount.current) {
      return
    }
    if (error) {
      return setState({ type: 'error', error })
    }
    setState({ type: 'ready', email: response.data.payload.email })
  }, [])

  useEffect(() => {
    void reload()
    return () => {
      isUnmount.current = true
    }
  }, [reload])

  return [state, reload] as const
}
